(function () {
  function gridContext(container) {
    return {
      collection_handle: container.dataset.collectionHandle || '',
      collection_title: container.dataset.collectionTitle || '',
      page_type: container.dataset.pageType || '',
      template: container.dataset.template || '',
      section_id: container.dataset.sectionId || '',
    };
  }

  function captureBrowseGridClick(container, el) {
    if (typeof window.posthog === 'undefined' || typeof window.posthog.capture !== 'function') {
      return;
    }

    var card = el.closest('.flat__card');
    var context = gridContext(container);
    var payload = {
      link_type: el.dataset.browseGridTrack,
      product_handle: card ? card.dataset.productHandle : '',
      product_title: card ? card.dataset.productTitle : '',
      destination_url: el.href || '',
      page_path: window.location.pathname,
      collection_handle: context.collection_handle,
      collection_title: context.collection_title,
      page_type: context.page_type,
      template: context.template,
      section_id: context.section_id,
    };

    if (el.dataset.browseGridTrack === 'app' && el.dataset.appName) {
      payload.app_name = el.dataset.appName;
    }

    window.posthog.capture('browse_product_grid_click', payload);
  }

  function initBrowseProductGridTracking(container) {
    if (!container || container.dataset.browseGridTrackingInit === 'true') return;
    container.dataset.browseGridTrackingInit = 'true';

    container.addEventListener('click', function (event) {
      var trackable = event.target.closest('[data-browse-grid-track]');
      if (!trackable) return;
      captureBrowseGridClick(container, trackable);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.v3__collection[data-browse-grid-tracking]').forEach(function (container) {
      initBrowseProductGridTracking(container);
    });
  });
})();
